interface Props {
  color?: string;
}

function Backbutton(props: Props) {
  const { color = "#64748B" } = props;

  return (
    <svg
      className="icon-size"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.4283 5.71436L7.14258 10.0001L11.4283 14.2858"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Backbutton;
